// NPM Imports
import React from "react";

// Component Imports
import AddAnotherRule from "./AddAnotherRule";
import AddAnotherRuleUpgrade from "./AddAnotherRuleUpgrade";
import { FeatureGating } from "../../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function(props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.WF_CLAUSE_OPTIONS}
      altComponent={
        <AddAnotherRuleUpgrade featureName={FEATURES_NAME.WF_CLAUSE_OPTIONS} />
      }>
      <AddAnotherRule {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/components/Template/TempWorkFlow/AddAnotherRule/index.js